import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_ADMISSION_FAILURE,
  ADD_ADMISSION_REQUEST,
  ADD_ADMISSION_SUCCESS,
  DELETE_ADMISSION_FAILURE,
  DELETE_ADMISSION_REQUEST,
  DELETE_ADMISSION_SUCCESS,
  EDIT_ADMISSION_FAILURE,
  EDIT_ADMISSION_REQUEST,
  EDIT_ADMISSION_SUCCESS,
  FETCH_ADMISSION_FAILURE,
  FETCH_ADMISSION_PARTICULAR_FAILURE,
  FETCH_ADMISSION_PARTICULAR_REQUEST,
  FETCH_ADMISSION_PARTICULAR_SUCCESS,
  FETCH_ADMISSION_PATIENT_FAILURE,
  FETCH_ADMISSION_PATIENT_REQUEST,
  FETCH_ADMISSION_PATIENT_SUCCESS,
  FETCH_ADMISSION_REQUEST,
  FETCH_ADMISSION_SUCCESS,
  FETCH_ADMISSIONS_BY_PHONE_NUMBER_FAILURE,
  FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST,
  FETCH_ADMISSIONS_BY_PHONE_NUMBER_SUCCESS,
  FETCH_ALL_LIST_ADMISSIONS_FAILURE,
  FETCH_ALL_LIST_ADMISSIONS_REQUEST,
  FETCH_ALL_LIST_ADMISSIONS_SUCCESS,
  FETCH_ALLS_LIST_ADMISSIONS_FAILURE,
  FETCH_ALLS_LIST_ADMISSIONS_REQUEST,
  FETCH_ALLS_LIST_ADMISSIONS_SUCCESS,
  FETCH_LIST_ADMISSIONS_FAILURE,
  FETCH_LIST_ADMISSIONS_REQUEST,
  FETCH_LIST_ADMISSIONS_SUCCESS,
  FETCH_REPORT_LIST_ADMISSIONS_FAILURE,
  FETCH_REPORT_LIST_ADMISSIONS_REQUEST,
  FETCH_REPORT_LIST_ADMISSIONS_SUCCESS,
  RESET_ADMISSIONS_BY_PHONE_NUMBER,
  RESET_CURRENT_ADMISSION,
  UPDATE_ADMISSION_FAILURE,
  UPDATE_ADMISSION_REQUEST,
  UPDATE_ADMISSION_SUCCESS,
  BULK_DISCHARGE_ADMISSION_REQUEST,
  BULK_DISCHARGE_ADMISSION_SUCCESS,
  BULK_DISCHARGE_ADMISSION_FAILURE,
} from "./admissionsType";

const initialState = {
  admissions: [],
  currentAdmission: null,
  fetchAdmissions: { ...defaultStatus },
  fetchAdmissionsAll: { ...defaultStatus },
  fetchAllAdmissions: { ...defaultStatus },
  fetchReport: { ...defaultStatus },
  fetchAdmission: { ...defaultStatus },
  fetchAdmissionPatients: { ...defaultStatus },
  addAdmission: { ...defaultStatus },
  updateAdmission: { ...defaultStatus },
  deleteAdmission: { ...defaultStatus },
  formMode: null,
  fetchAdmissionsByPhoneNumber: { ...defaultStatus },
  editAdmission:{ ...defaultStatus},
  fetchAdmissionParticular: { ...defaultStatus },
  bulkDischargeAdmission: { ...defaultStatus },
};

const AdmissionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchAdmissionsAll: { ...state.fetchAdmissionsAll, inProgress: true },
      };
    case FETCH_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchAdmissionsAll: {
          ...state.fetchAdmissionsAll,
          success: true,
          inProgress: false,
          admissions: payload?.admissions,
        },
      };
    case FETCH_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchAdmissionsAll: {
          ...state.fetchAdmissionsAll,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_ALLS_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchAdmission: { ...state.fetchAdmission, inProgress: true },
      };
    case FETCH_ALLS_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchAllAdmission: {
          ...state.fetchAllAdmission,
          success: true,
          inProgress: false,
          admissions: payload?.admissions,
        },
      };
    case FETCH_ALLS_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchAllAdmissions: {
          ...state.fetchAllAdmissions,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_ALL_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchAdmissions: { ...state.fetchAdmissions, inProgress: true },
      };
    case FETCH_ALL_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchAllAdmissions: {
          ...state.fetchAllAdmissions,
          success: true,
          inProgress: false,
          admissions: payload?.admissions,
        },
      };
    case FETCH_ALL_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchAllAdmissions: {
          ...state.fetchAllAdmissions,
          error: true,
          errorMessage: payload.error,
        },
      };

    case FETCH_REPORT_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchReport: { ...state.fetchAdmissions, inProgress: true },
      };
    case FETCH_REPORT_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchReport: {
          ...state.fetchReport,
          success: true,
          inProgress: false,
          admissions: payload?.admissions,
        },
      };
    case FETCH_REPORT_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchReport: {
          ...state.fetchReport,
          error: true,
          errorMessage: payload?.error,
        },
      };
    case FETCH_ADMISSION_REQUEST:
      const { admissionId } = payload;
      return {
        ...state,
        fetchAdmission: {
          ...state.fetchAdmission,
          inProgress: true,
          admissionId,
        },
      };
    case FETCH_ADMISSION_SUCCESS:
      return {
        ...state,
        fetchAdmission: {
          ...state.fetchAdmission,
          success: true,
          inProgress: false,
          data: payload?.admissions,
        },
      };
    case FETCH_ADMISSION_FAILURE:
      return {
        ...state,
        fetchAdmission: {
          ...state.fetchAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case FETCH_ADMISSION_PATIENT_REQUEST:
      const { admissionIdS } = payload;
      return {
        ...state,
        fetchAdmissionPatients: {
          ...state.fetchAdmissionPatients,
          inProgress: true,
          admissionIdS,
        },
      };
    case FETCH_ADMISSION_PATIENT_SUCCESS:
      return {
        ...state,
        fetchAdmissionPatients: {
          ...state.fetchAdmissionPatients,
          success: true,
          inProgress: false,
          data: payload?.admissions,
        },
      };
    case FETCH_ADMISSION_PATIENT_FAILURE:
      return {
        ...state,
        fetchAdmissionPatients: {
          ...state.fetchAdmissionPatients,
          error: true,
          errorMessage: payload.error,
        },
      };

    case ADD_ADMISSION_REQUEST:
      return {
        ...state,
        addAdmission: { ...state.addAdmission, inProgress: true },
      };
    case ADD_ADMISSION_SUCCESS:
      return {
        ...state,
        addAdmission: {
          ...state.addAdmission,
          success: true,
          error: false,
          inProgress: false,
        },
      };
    case ADD_ADMISSION_FAILURE:
      return {
        ...state,
        addAdmission: {
          ...state.addAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case UPDATE_ADMISSION_REQUEST:
      return {
        ...state,
        updateAdmission: { ...state.updateAdmission, inProgress: true },
      };
    case UPDATE_ADMISSION_SUCCESS: {
      const updatedAdmission = payload.Admission;
      return {
        ...state,
        updateAdmission: {
          ...state.updateAdmission,
          success: true,
          inProgress: false,
        },
        admissions: state.admissions.map((admission) =>
          admission.id === updatedAdmission.id ? updatedAdmission : admission
        ),
        currentAdmission: updatedAdmission,
      };
    }
    case UPDATE_ADMISSION_FAILURE:
      return {
        ...state,
        updateAdmission: {
          ...state.updateAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case DELETE_ADMISSION_REQUEST:
      return {
        ...state,
        deleteAdmission: { ...state.deleteAdmission, inProgress: true },
      };
    case DELETE_ADMISSION_SUCCESS:
      return {
        ...state,
        deleteAdmission: {
          ...state.deleteAdmission,
          success: true,
          inProgress: false,
        },
        admissions: state.admissions.filter(
          (admission) => admission.id !== payload.AdmissionId
        ),
        currentAdmission:
          state.currentAdmission?.id === payload.AdmissionId
            ? null
            : state.currentAdmission,
      };
    case DELETE_ADMISSION_FAILURE:
      return {
        ...state,
        deleteAdmission: {
          ...state.deleteAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case RESET_CURRENT_ADMISSION:
      return {
        ...state,
        addAdmission: { ...defaultStatus },
        updateAdmission: { ...defaultStatus },
        bulkDischargeAdmission: { ...defaultStatus },
        currentAdmission: null,
      };

    case FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST:
      return {
        ...state,
        fetchAdmissionsByPhoneNumber: {
          ...state.fetchAdmissionsByPhoneNumber,
          inProgress: true,
        },
      };
    case FETCH_ADMISSIONS_BY_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        fetchAdmissionsByPhoneNumber: {
          ...state.fetchAdmissionsByPhoneNumber,
          success: true,
          inProgress: false,
          admissions: payload?.admissions,
        },
      };
    case FETCH_ADMISSIONS_BY_PHONE_NUMBER_FAILURE:
      return {
        ...state,
        fetchAdmissionsByPhoneNumber: {
          ...state.fetchAdmissionsByPhoneNumber,
          error: true,
          errorMessage: payload.error,
        },
      };
  case EDIT_ADMISSION_REQUEST:
      return {
        ...state,
        editAdmission: { ...state.editAdmission, inProgress: true, error: null }
      }
    case EDIT_ADMISSION_SUCCESS: {
      return {
        ...state,
        editAdmission: {
            ...state.editAdmission,
            inProgress: false,
            success: true,
            data: payload?.patient
          },
      }
    }
    case  EDIT_ADMISSION_FAILURE:
      return {
        ...state,
        editAdmission: {
            ...state.editAdmission,
            inProgress: false,
            success: false,
            error: true,
            errorMessage: payload?.errorMessage || null,
            ...payload
          }
        }
        case FETCH_ADMISSION_PARTICULAR_REQUEST:
      return {
        ...state,
        fetchAdmissionParticular: {
          ...state.fetchAdmissionParticular,
          inProgress: true,
        },
      };
    case FETCH_ADMISSION_PARTICULAR_SUCCESS:
      return {
        ...state,
        fetchAdmissionParticular: {
          ...state.fetchAdmissionParticular,
          success: true,
          inProgress: false,
          admission: payload?.admission,
        },
      };
    case FETCH_ADMISSION_PARTICULAR_FAILURE:
      return {
        ...state,
        fetchAdmissionParticular: {
          ...state.fetchAdmissionParticular,
          error: true,
          errorMessage: payload.error,
        },
      };

      case BULK_DISCHARGE_ADMISSION_REQUEST:
        return {
          ...state,
          bulkDischargeAdmission: { ...state.bulkDischargeAdmission, inProgress: true },
        };
      case BULK_DISCHARGE_ADMISSION_SUCCESS:
        return {
          ...state,
          bulkDischargeAdmission: {
            ...state.bulkDischargeAdmission,
            success: true,
            inProgress: false,
          },
        };
      case BULK_DISCHARGE_ADMISSION_FAILURE:
        return {
          ...state,
          bulkDischargeAdmission: {
            ...state.bulkDischargeAdmission,
            error: true,
            errorMessage: payload.error,
          },
        };
    case RESET_ADMISSIONS_BY_PHONE_NUMBER:
      return {
        ...state,
        fetchAdmissionsByPhoneNumber: { ...defaultStatus },
      };

    default:
      return state;
  }
};

export default AdmissionReducer;
